import { is } from 'stdlib/is'

import before from './before'

/**
 * Létrehoz egy script elemet, ha még nem található a DOM-ban és berakja a head-be.
 * @param src        - A source url.
 * @param scriptType - A script típusa.
 */
export default function createScript (src: string, scriptType: null | 'module' = null): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const scriptElement = Array
      .from(document.querySelectorAll<HTMLScriptElement>('script[src]'))
      .find((script) => script.src.split('?')?.[0]?.includes(src))

    const isAlreadyCreated = !is.undefined(scriptElement)

    if (isAlreadyCreated) {
      resolve(isAlreadyCreated)

      return
    }

    const script = document.createElement('script')
    script.async = true
    // oxlint-disable-next-line no-restricted-globals -- Itt most jó a global Date.
    script.src   = `${ src }?t=${ Date.now() }` // no-cache

    if (scriptType) {
      script.type = scriptType
    }

    script.addEventListener('load', () => {
      resolve(isAlreadyCreated)
    })

    script.addEventListener('error', (error) => {
      reject(error)
    })

    const [ s ] = Array.from(document.scripts)

    if (s) {
      before(script, s)
    }
  })
}
